import { gunzipSync } from 'fflate';

/**
 * Convert base64 string to Uint8Array
 */
function base64ToUint8Array(base64: string): Uint8Array {
  const binaryString = atob(base64);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes;
}

/**
 * Decompress gzip-compressed base64 string to original string
 * @param base64Gzipped - gzip compressed data as base64 string
 * @returns decompressed string
 */
export function decompressData(base64Gzipped: string): string {
  const compressedData = base64ToUint8Array(base64Gzipped);
  const decompressedData = gunzipSync(compressedData);
  return new TextDecoder('utf-8').decode(decompressedData);
}
